/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-22 13:56:47
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-09-24 13:18:14
 * @FilePath: \hlweb2.0\src\components\Jump\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react'
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
const JumpApply = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const click = () => {
    history.push("/apply");
  };
  return <span className='jumpApply_span' onClick={click} style={{cursor:'pointer'}}>{t("navigation.experience")}</span>;
};


export {JumpApply };